<div class="message-report-sent">
    <div class="message-report-sent__img"></div>
    <div class="message-report-sent__text">
        <span class="message-report-sent__text-red">{{TEXT.others.messageReportSendError}} </span>
        <span *ngIf="nameReport">{{TEXT.others.messageReportSendErrorEnd}} «{{nameReport}}»</span>
        <span *ngIf="!nameReport">{{TEXT.others.messageReportSendErrorDefault}}</span>
    </div>
</div>